import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {
    FormsModule,
    ReactiveFormsModule,
    UntypedFormBuilder,
    UntypedFormControl,
    UntypedFormGroup,
    Validators
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ResetPassword } from '@zlib/data-access/models/user.model';
import { AuthService, ModalAction } from '@zlib/services/auth.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastService } from '@zlib/services/toast.service';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzSpinModule } from 'ng-zorro-antd/spin';

@Component({
    selector: 'app-set-password',
    templateUrl: './set-password.component.html',
    styleUrls: ['./set-password.component.scss'],
    imports: [
        TranslateModule,
        NzInputModule,
        NzFormModule,
        NzCardModule,
        FormsModule,
        ReactiveFormsModule,
        NzSpinModule
    ]
})
export class SetPasswordComponent implements OnInit {
    @Output() isLoginEvent = new EventEmitter<boolean>();

    ModalAction = ModalAction;
    resetForm!: UntypedFormGroup;
    loading = false;
    submitted = false;
    error = '';
    isSave = false;
    code = '';
    email = '';

    constructor(
        private readonly fb: UntypedFormBuilder,
        private readonly authService: AuthService,
        private readonly toastService: ToastService,
        private readonly router: Router,
        private readonly translateService: TranslateService,
        private readonly activatedRoute: ActivatedRoute
    ) {
        this.activatedRoute.queryParams.subscribe((params) => {
            this.code = params['code'];
            this.email = params['email'];

            if (this.code === '') {
                this.router.navigate(['']);
            }

            if (this.email === '') {
                this.router.navigate(['']);
            }
        });
    }

    ngOnInit(): void {
        this.resetForm = this.fb.group({
            email: new UntypedFormControl('', [
                Validators.required,
                Validators.email
            ]),
            password: new UntypedFormControl('', [this.strongPassword]),
            confirmPassword: new UntypedFormControl(null, [
                this.passwordConfirmValidator
            ])
        });

        this.resetForm.controls['email'].setValue(this.email);
    }

    strongPassword = (
        control: UntypedFormControl
    ): { [s: string]: boolean } => {
        const lengthRequired = control.value.length >= 8;
        // const hasNumber = /\d/.test(control.value);
        // const hasUpper = /[A-Z]/.test(control.value);
        // const hasLower = /[a-z]/.test(control.value);
        // const special = /[!@#$%^&*_-]/.test(control.value);

        if (!lengthRequired) {
            return { length: true };
        }
        // else if (!hasLower) {
        //     return { lower: true };
        // } else if (!hasUpper) {
        //     return { upper: true };
        // } else if (!hasNumber) {
        //     return { number: true };
        // } else if (!special) {
        //     return { special: true };
        // }

        return {};
    };

    passwordConfirmValidator = (
        control: UntypedFormControl
    ): { [s: string]: boolean } => {
        if (!control.value) {
            return { required: true };
        } else if (control.value.length < 6) {
            return { min: true, error: true };
        } else if (
            control.value !== this.resetForm.controls['password'].value
        ) {
            return { confirm: true, error: true };
        }
        return {};
    };

    validateForm() {
        // eslint-disable-next-line guard-for-in
        for (const i in this.resetForm.controls) {
            this.resetForm.controls[i].markAsDirty();
            this.resetForm.controls[i].updateValueAndValidity();
        }

        return !this.resetForm.invalid;
    }

    onChangePassword() {
        const formValid = this.validateForm();

        if (!formValid) {
            return;
        }

        this.loading = true;
        const form = this.resetForm.getRawValue();
        const resetPassword = {
            code: this.code,
            email: form.email,
            password: form.password
        } as ResetPassword;
        this.authService.resetPassword(resetPassword).subscribe(
            (res: any) => {
                this.loading = false;
                if (res.result) {
                    this.toastService.createSuccessNotification(
                        this.translate('login.notification.password_updated'),
                        ''
                    );
                    this.router.navigate(['/']);
                    this.authService.openLogin.next(ModalAction.Login);
                } else {
                    this.toastService.createErrorNotification(
                        this.translate(
                            'login.notification.fail_password_updated'
                        ),
                        ''
                    );
                }
            },
            (err) => {
                this.loading = false;
                this.toastService.createErrorNotification(
                    this.translate('login.notification.code_incorrect'),
                    ''
                );
            }
        );
    }

    onViewPassword() {
        const password = <HTMLInputElement>document.getElementById('password');
        password.type = password.type === 'password' ? 'text' : 'password';
    }

    onViewConfirmPassword() {
        const password = <HTMLInputElement>(
            document.getElementById('confirmPassword')
        );
        password.type = password.type === 'password' ? 'text' : 'password';
    }

    translate(str: string) {
        return this.translateService.instant(str);
    }
}
